import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
import { Row, Col, Card, Button, ButtonGroup, ToggleButton, ToggleButtonGroup } from 'react-bootstrap'

function simulateNetworkRequest() {
    return new Promise(resolve => setTimeout(resolve, 2000));
}


function UiButtons() {

    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        if (isLoading) {
            simulateNetworkRequest().then(() => {
                setLoading(false);
            });
        }
    }, [isLoading]);

    const handleClick = () => setLoading(true);

    // 

    const [value, setValue] = useState([1, 3]);

    const handleChange = val => setValue(val);

    return (
        <>
            <Row>

                <Col xl={6}>
                    <Card>
                        <Card.Header>
                            <Card.Title>Basic</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <Button variant="primary mb-2 mr-2">Primary</Button>{' '}
                            <Button variant="secondary mb-2 mr-2">Secondary</Button>{' '}
                            <Button variant="success mb-2 mr-2">Success</Button>{' '}
                            <Button variant="warning mb-2 mr-2">Warning</Button>{' '}
                            <Button variant="danger mb-2 mr-2">Danger</Button> <Button variant="info">Info</Button>{' '}
                            <Button variant="light mb-2 mr-2">Light</Button> <Button variant="dark">Dark</Button>{' '}
                            <Button variant="link mb-2 mr-2">Link</Button>
                        </Card.Body>
                    </Card>
                </Col>

                <Col xl={6}>
                    <Card>
                        <Card.Header>
                            <Card.Title>Outline</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <Button variant="outline-primary mb-2 mr-2">Primary</Button>{' '}
                            <Button variant="outline-secondary mb-2 mr-2">Secondary</Button>{' '}
                            <Button variant="outline-success mb-2 mr-2">Success</Button>{' '}
                            <Button variant="outline-warning mb-2 mr-2">Warning</Button>{' '}
                            <Button variant="outline-danger mb-2 mr-2">Danger</Button>{' '}
                            <Button variant="outline-info mb-2 mr-2">Info</Button>{' '}
                            <Button variant="outline-light mb-2 mr-2">Light</Button>{' '}
                            <Button variant="outline-dark mb-2 mr-2">Dark</Button>
                        </Card.Body>
                    </Card>
                </Col>

                <Col xl={6}>
                    <Card>
                        <Card.Header>
                            <Card.Title>Tag</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <Button href="#"  className="mb-2 mr-2">Link</Button> <Button  className="mb-2 mr-2" type="submit">Button</Button>{' '}
                            <Button as="input" className="mb-2 mr-2" type="button" value="Input" />{' '}
                            <Button as="input"  className="mb-2 mr-2" type="submit" value="Submit" />{' '}
                            <Button as="input"  className="mb-2 mr-2" type="reset" value="Reset" />
                        </Card.Body>
                    </Card>
                </Col>

                <Col xl={6}>
                    <Card>
                        <Card.Header>
                            <Card.Title>Size</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <Button variant="primary" className="mb-2 mr-2" size="lg">Large button</Button>{' '}
                            <Button variant="secondary" className="mb-2 mr-2" size="lg">Large button</Button>
                            <Button variant="primary" className="mb-2 mr-2" size="sm">Small button</Button>{' '}
                            <Button variant="secondary" className="mb-2 mr-2" size="sm">Small button</Button>
                        </Card.Body>
                    </Card>
                </Col>

                <Col xl={6}>
                    <Card>
                        <Card.Header>
                            <Card.Title>Block</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <Button variant="primary" className="mb-2 mr-2" size="lg" block>Block level button</Button>
                            <Button variant="secondary" className="mb-2 mr-2" size="lg" block>Block level button</Button>
                        </Card.Body>
                    </Card>
                </Col>

                <Col xl={6}>
                    <Card>
                        <Card.Header>
                            <Card.Title>Disabled</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <Button variant="primary" size="lg" disabled>Primary button</Button>{' '}
                            <Button variant="secondary" size="lg" disabled>Button</Button>{' '}
                            <Button href="#" variant="secondary" size="lg" disabled>Link</Button>
                        </Card.Body>
                    </Card>
                </Col>

                <Col xl={6}>
                    <Card>
                        <Card.Header>
                            <Card.Title>Loading</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <Button
                                variant="primary"
                                disabled={isLoading}
                                onClick={!isLoading ? handleClick : null}
                            >
                                {isLoading ? 'Loading…' : 'Click to load'}
                            </Button>
                        </Card.Body>
                    </Card>
                </Col>

                <Col xl={6}>
                    <Card>
                        <Card.Header>
                            <Card.Title>Checkbox / Radio</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <ButtonGroup toggle className="mr-2">
                                <ToggleButton type="checkbox" defaultChecked value="1">
                                    Checked
                                </ToggleButton>
                            </ButtonGroup>

                            <ButtonGroup toggle>
                                <ToggleButton type="radio" name="radio" defaultChecked value="1">
                                    Active
                                </ToggleButton>
                                <ToggleButton type="radio" name="radio" value="2">
                                    Radio
                                </ToggleButton>
                                <ToggleButton type="radio" name="radio" value="3">
                                    Radio
                                </ToggleButton>
                            </ButtonGroup>
                        </Card.Body>
                    </Card>
                </Col>

                <Col xl={6}>
                    <Card>
                        <Card.Header>
                            <Card.Title>Uncontrolled</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <ToggleButtonGroup type="checkbox" defaultValue={[1, 3]} className="mb-2">
                                <ToggleButton value={1}>Checkbox 1 (pre-checked)</ToggleButton>
                                <ToggleButton value={2}>Checkbox 2</ToggleButton>
                                <ToggleButton value={3}>Checkbox 3 (pre-checked)</ToggleButton>
                            </ToggleButtonGroup>
                            <br />
                            <ToggleButtonGroup type="radio" name="options" defaultValue={1}>
                                <ToggleButton value={1}>Radio 1 (pre-checked)</ToggleButton>
                                <ToggleButton value={2}>Radio 2</ToggleButton>
                                <ToggleButton value={3}>Radio 3</ToggleButton>
                            </ToggleButtonGroup>
                        </Card.Body>
                    </Card>
                </Col>

                <Col xl={6}>
                    <Card>
                        <Card.Header>
                            <Card.Title>Controlled</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <ToggleButtonGroup type="checkbox" value={value} onChange={handleChange}>
                                <ToggleButton value={1}>Option 1</ToggleButton>
                                <ToggleButton value={2}>Option 2</ToggleButton>
                                <ToggleButton value={3}>Option 3</ToggleButton>
                            </ToggleButtonGroup>
                        </Card.Body>
                    </Card>
                </Col>

            </Row>
        </>
    )
}

export default UiButtons;